var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembersSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 10.0833C16.1883 10.0833 17.4075 8.85501 17.4075 7.33334C17.4075 5.81168 16.1883 4.58334 14.6666 4.58334C13.145 4.58334 11.9166 5.81168 11.9166 7.33334C11.9166 8.85501 13.145 10.0833 14.6666 10.0833ZM7.33329 10.0833C8.85496 10.0833 10.0741 8.85501 10.0741 7.33334C10.0741 5.81168 8.85496 4.58334 7.33329 4.58334C5.81163 4.58334 4.58329 5.81168 4.58329 7.33334C4.58329 8.85501 5.81163 10.0833 7.33329 10.0833ZM7.33329 11.9167C5.19746 11.9167 0.916626 12.9892 0.916626 15.125V17.4167H13.75V15.125C13.75 12.9892 9.46913 11.9167 7.33329 11.9167ZM14.6666 11.9167C14.4008 11.9167 14.0983 11.935 13.7775 11.9625C14.8408 12.7325 15.5833 13.7683 15.5833 15.125V17.4167H21.0833V15.125C21.0833 12.9892 16.8025 11.9167 14.6666 11.9167Z",
    fill: "#005BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersSelectedIcon);
export default __webpack_public_path__ + "static/media/MembersSelectedIcon.617b20acebf6a8e695695afeccf451b2.svg";
export { ForwardRef as ReactComponent };